import bankEdwards from '../../banksPNG/bankEdwards.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoEdwardsIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Edwards',
}: IconProps) => <img src={bankEdwards} width={width} height={height} alt={alt} />;
